export enum Status {
  DRAFT = 1,
  PUBLISHED = 2,
  REMOVED = 3,
}
